<template>
  <div id="app">
    <congrats></congrats>
    <div v-if="getIsCharging">
      <div
        class="three w-100 d-flex align-items-center"
        :class="userIsAParent ? 'bg-plain' : 'bg-light'"
        style="height: 100vh;"
      >
        <div class="loader" id="loader-1"></div>
      </div>
    </div>
    <div class="bg-medium" :class="userIsAParent ? '' : 'bg-light'" v-else>
      <login v-if="!getUserIsLogged" style="height: 100vh;" class="parent"></login>

      <div v-else id="app-wrapper-web" class="d-lg-flex  m-auto" :class="{ parent: userIsAParent }">
        <nav-bar-side v-if="userIsAParent" class="d-none d-lg-block w-25 bg-main py-5" />
        <div
          class="d-flex flex-column w-100 w-lg-75 overflow-auto vh-100"
          :style="`background-image: url('${require('@/assets/background/child-app-bg.svg')}');`"
        >
          <!-- parent header -->
          <nav-bar v-if="userIsAParent" />
          <!-- child header -->
          <user-data v-if="!userIsAParent" />
          <!-- view content -->
          <router-view
            class="w-100 main-app-wrapper-content bar-side"
            :class="
              (!userIsAParent ? 'bar-side--full ' : 'bg-light ') +
                (!isOnEspecialView || (!userIsAParent && isMobile) ? 'scrollable-container' : '')
            "
          />
        </div>
        <div class="d-lg-flex "></div>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/general/navBar.vue';
import NavBarSide from '@/components/general/navBarSide.vue';
import Login from '@/views/user/Login';
import { mapActions, mapGetters } from 'vuex';
import UserData from './components/header/userData.vue';
import Congrats from './components/congrats/congrats.vue';

export default {
  components: {
    NavBar,
    NavBarSide,
    Login,
    UserData,
    Congrats,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', ['getUserIsLogged', 'getUserId', 'getUserIdUnique', 'userIsAParent']),
    ...mapGetters('general', ['getIsCharging']),
    ...mapGetters('parent', ['getChildrenData']),
    isOnEspecialView() {
      return !!['/rewards', '/'].find((f) => f == this.$route.path);
    },
    isMobile() {
      return !!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );
    },
  },
  methods: {
    ...mapActions('notifications', ['fethNotifications']),
    ...mapActions('general', ['setSession']),
    ...mapActions('user', ['getUserData']),
    ...mapActions('badges', ['FetchParentBadges', 'FetchChildBadges']),
  },
  mounted() {
    window.onbeforeunload = () => {
      this.setSession({
        route: '/close-tab',
        userId: this.getUserIdUnique,
      });
      return null;
    };
  },
  beforeUpdate() {
    if (this.getUserIsLogged && this.getIsCharging == false) {
      this.fethNotifications({
        userId: this.getUserId,
        userIsAparent: this.userIsAParent,
      });
    }
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

.parent {
  * {
    font-weight: normal !important;
    text-transform: none !important;
  }
}

*:not(input),
*:not(.material-icons) {
  font-family: 'Poppins', sans-serif;
  font-weight: bold;
}

html,
body {
  height: 100%;
  font-size: 18px !important;
  @media screen and (max-width: 769px) {
    font-size: 16px !important;
  }
}
#app {
  font-family: 'Roboto', Avenir, Helvetica, Arial, sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1a1a1a;
  height: 100%;
  overflow: hidden;
}

.main-app-wrapper-content {
  overflow-y: auto;
  overflow-x: hidden;
}

.scrollable-container {
  padding-bottom: 150px !important;
}

.bar-side {
  // height: calc(100vh - 63px) !important;
  height: 100% !important;
}
.bar-side--full {
  height: 100vh !important;
}
p {
  margin: 0 !important;
}
:root {
  --color-home: #57b8ff;
  --color-challenges: #c9f0a7;
  --color-rewards: #fbca7e;
  --color-badges: #8fe9cc;
  --color-progress: #aadbff;

  --color-upp: #416b69;
  --color-low: #416b69;
  --color-main: #6fa6a3;
  --color-main2: #0071cc;
  --color-plain: #daf7ee;
  --color-plain2: #d2e9f7;
  --color-blue-light: #bbeedf;
  --color-blue-light2: #a7d6f4;
  --color-help: #d79b95;
  --color-dark: #112a29;

  --bg-gradient: linear-gradient(var(--color-upp) 0%, var(--color-low) 100%);

  --color-orange: #f2cb8a;

  --aside: #778fa6;
  --light2: #e6e6e6;

  --aside01: #a67a77;
  --aside02: #778fa6;
  --aside03: #67a67f;
  --aside04: #a68280;
  --aside05: #f2cb8a;
  --aside06: #9580a6;

  --aside001: #e26a89;
  --aside002: #f2cb8a;
  --aside003: #005bb5;
  --aside004: #ff9999;

  --info: #416b69 !important;
  --warning: #416b69 !important;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: var(--aside003) !important;
  color: #fff !important;
}

.a,
.nav-link {
  color: var(--aside003) !important;
}

.nav-link.disabled {
  color: #6c757d !important;
  pointer-events: none;
  cursor: default;
}

.form-control:focus,
.custom-select:focus {
  box-shadow: none !important;
}

a {
  color: var(--aside003) !important;
}

a.b-link {
  padding: 10px 30px;
}

a.b-link:hover {
  color: var(--aside003) !important;
  text-decoration: none !important;
  background-color: #fafafa;
  border-radius: 50px;
}

.btn-warning {
  border-radius: 50px !important;
}

.btn-warning.disabled,
.btn-warning:disabled {
  color: #212529 !important;
  background-color: var(--color-orange) !important;
  border-color: var(--color-orange) !important;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff !important;
  border-color: var(--color-main) !important;
  background-color: var(--color-main) !important;
}

.btn-warning {
  color: #212529 !important;
  background-color: var(--color-orange) !important;
  border-color: var(--color-orange) !important;
}

.text-primary {
  color: var(--color-main) !important;
}

.btn-outline-primary {
  color: var(--color-main) !important;
  border-color: var(--color-main) !important;
}

.btn-info {
  color: #fff !important;
  background-color: var(--color-help) !important;
  border-color: var(--color-help) !important;
}

.bg-primary {
  background-color: var(--color-main) !important;
}

.bg-gradient {
  background: var(--bg-gradient);
}
.bg-main {
  background-color: var(--color-main) !important;
  border: 0 !important;
}
.bg-main2 {
  background-color: var(--color-main2) !important;
  border: 0 !important;
}
.outline-main {
  background-color: transparent !important;
  border-color: var(--color-main) !important;
  color: var(--color-main) !important;
}
.outline-main:hover {
  background-color: var(--color-main) !important;
  color: #fff !important;
}
.bg-plain {
  background-color: var(--color-plain) !important;
}
.bg-plain2 {
  background-color: var(--color-plain2) !important;
}
.bg-blue-light {
  background-color: var(--color-blue-light) !important;
}
.bg-upp {
  background-color: var(--color-upp) !important;
  border: var(--color-upp) !important;
  color: #fff !important;
}
.bg-help {
  background-color: var(--color-help) !important;
  color: #fff !important;
}
.bg-darked {
  background-color: var(--color-dark) !important;
}
.bg-aside {
  background-color: var(--aside) !important;
  border: var(--aside) !important;
}
.bg-light2 {
  background-color: var(--light2) !important;
  border: var(--light2) !important;
}
.bg-aside01 {
  background-color: var(--aside01) !important;
  border: var(--aside01) !important;
  color: #fff !important;
}
.bg-aside02 {
  background-color: var(--aside02) !important;
  border: var(--aside02) !important;
  color: #fff !important;
}
.bg-aside03 {
  background-color: var(--aside03) !important;
  border: var(--aside03) !important;
  color: #fff !important;
}
.bg-aside04 {
  background-color: var(--aside04) !important;
  border: var(--aside04) !important;
  color: #fff !important;
}
.bg-aside05 {
  background-color: var(--aside05) !important;
  border: var(--aside05) !important;
  color: #fff !important;
}
.bg-aside06 {
  background-color: var(--aside06) !important;
  border: var(--aside06) !important;
  color: #fff !important;
}
.bg-aside01-outline {
  background-color: transparent !important;
  color: var(--aside01) !important;
  border-color: var(--aside01) !important;
}
.bg-aside001-outline {
  background-color: transparent !important;
  color: var(--aside001) !important;
  border-color: var(--aside001) !important;
}
.bg-aside02-outline {
  background-color: transparent !important;
  color: var(--aside02) !important;
  border-color: var(--aside02) !important;
}
.bg-aside03-outline {
  background-color: transparent !important;
  color: var(--aside03) !important;
  border-color: var(--aside03) !important;
}
.bg-aside01-outline:hover {
  color: #fff !important;
  background-color: var(--aside01) !important;
  border-color: var(--aside01) !important;
}
.bg-aside001-outline:hover {
  color: #fff !important;
  background-color: var(--aside001) !important;
  border-color: var(--aside001) !important;
}
.bg-aside02-outline:hover {
  color: #fff !important;
  background-color: var(--aside02) !important;
  border-color: var(--aside02) !important;
}
.bg-aside03-outline:hover {
  color: #fff !important;
  background-color: var(--aside03) !important;
  border-color: var(--aside03) !important;
}
.bg-opacity {
  background: rgba(0, 0, 0, 0.08);
}
.text-aside01 {
  color: var(--aside01) !important;
}
.text-aside05 {
  color: var(--aside05) !important;
}
.text-aside001 {
  color: var(--aside001) !important;
}
.text-orange {
  color: var(--orange) !important;
}
.text-help {
  color: var(--color-help) !important;
}
.text-darked {
  color: var(--color-dark) !important;
}
.text-main {
  color: var(--color-main) !important;
}
.text-main2 {
  color: var(--color-main2) !important;
}
.smaller {
  font-size: 1.2em;
}
.time-challenge .card-header {
  background-color: transparent;
}
.time-challenge .card-body {
  padding: 0 !important;
}
.time-challenge .nav-tabs .nav-link.disabled {
  color: #ccc;
}

.icon-star-small {
  width: 0.9em;
}

.star-uncheck {
  color: #cbced1;
}
.star-checked {
  color: #f2cb8a;
}

.border-2 {
  background-color: #f2f2f2;
  color: #999999;
  font-size: 1.2em !important;
  padding: 0.1em !important;
}
.border-muted {
  border: 1px solid #e6e6e6;
}

.full-icon {
  font-size: 8em !important;
  color: #e6e6e6;
}

img.filter-gray {
  filter: grayscale(100%);
}

.card-header {
  padding: 0.75rem 0.25rem !important;
}

@media (min-width: 768px) {
  .btn-block {
    width: 50% !important;
    margin: 0 auto;
  }
}

.pointer {
  cursor: pointer;
}
.move {
  cursor: move !important;
}

.d-grid {
  display: grid;
}

.user-select-none {
  user-select: none;
}

.text-normal {
  text-transform: none;
}

.flex-gap {
  gap: 1rem;
}
/* LOADER PAGE */
.loader {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  position: relative;
  margin: 0 auto;
}
#loader-1:before,
#loader-1:after {
  content: '';
  position: absolute;
  top: -10px;
  left: -10px;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: 10px solid transparent;
  border-top-color: var(--color-dark);
}
#loader-1:before {
  z-index: 100;
  animation: spin 1s infinite;
}
#loader-1:after {
  border: 10px solid #ccc;
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
/** inputs style **/

:focus {
  outline: none;
}
.inputs-container {
  .input-upper {
    position: relative;
    margin: 10px auto 0px auto;
    textarea {
      overflow-y: hidden;
      // overflow-x: auto;
      white-space: pre;
      overflow-wrap: normal;
      resize: none;
      height: 42.5px;

      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }
    textarea::-webkit-scrollbar {
      display: none;
    }

    input,
    textarea {
      border: 0;
      border-bottom: 1px solid grey;
      position: relative;
      outline: 0;
      border-radius: 0;
      padding: 15px 10px;
      // width: 300px;
      transition: all 0.5s ease;
      z-index: 1;
      background-color: transparent;
    }
    ::placeholder {
      color: #aaa;
    }
    label {
      position: absolute;
      left: 20px;
      top: 6px;
      transition: all 0.3s ease;
      color: gray;
    }
    label.plx-3 {
      left: 38px;
    }
    input:focus,
    textarea:focus,
    input:valid,
    textarea:valid {
      border-bottom: 1px solid var(--color-main);
    }
    input:focus ~ label,
    textarea:focus ~ label,
    input:valid ~ label,
    textarea:valid ~ label {
      transform: translate3d(0px, -31px, 0px);
      top: 14px;
      text-transform: uppercase;
      font-size: 12px;
      color: var(--color-main);
    }
    input:focus ~ label.plx-3,
    textarea:focus ~ label.plx-3,
    input:valid ~ label.plx-3,
    textarea:valid ~ label.plx-3 {
      left: 20px;
    }
  }
  .input-date {
    margin-top: 20px;
    .b-form-datepicker {
      border: 0;
      border-bottom: 1px solid grey;
      outline: 0;
      border-radius: 0;
      button {
        svg {
          font-size: inherit;
        }
      }
    }
    .custom-select {
      border: 0;
      border-bottom: 1px solid grey;
      outline: 0;
      border-radius: 0;
    }
    label.label-date {
      // transform: translate3d(0px, -31px, 0px);
      position: relative;
      left: 5px;
      top: 5px;
      text-transform: uppercase;
      font-size: 12px;
      color: var(--color-main);
    }
  }
}

.inputs-container .input-date .b-form-datepicker {
  background-color: transparent;
  font-size: 16px;
}

.inputs-container .input-date .custom-select {
  background-color: transparent;
}

.custom-checkbox.b-custom-control-lg .custom-control-label::before,
.input-group-lg .custom-checkbox .custom-control-label::before {
  border-radius: 50px !important;
}

.darker-hover:hover {
  background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));
  .darker {
    background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));
  }
}

.vh-100 {
  height: 100vh;
}
</style>
